import React from 'react';
import { observer, inject } from 'mobx-react';
import { Theme, Modal, Paper, Typography, Button } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import { WithTranslation, withTranslation } from 'react-i18next';

import { WizardModel } from '../../models/kiosk/WizardModel';
import { Billpay } from '../../models/kiosk/Billpay';
import { Services } from '../../helpers/constants/Services';
import { ModalProps } from '@mui/material/Modal';
import { ButtonProps } from '@mui/material/Button';
import { defaultStyle } from './CommonModalStyles';

type ModalWithoutChildrenProps = Omit<ModalProps, 'children'>;

interface PaymentProcessFailedModalProps
    extends WithStyles<typeof styles>,
        WithTranslation {
    modalProps?: ModalWithoutChildrenProps;
    buttonProps?: ButtonProps;
}
interface PaymentProcessFailedModalPropsInjected
    extends PaymentProcessFailedModalProps {
    wizard: WizardModel;
    billpay: Billpay;
}

const styles = (theme: Theme) =>
    createStyles(defaultStyle);

@inject(Services.BILLPAY)
@observer
class PaymentProcessFailedModal extends React.Component<
    PaymentProcessFailedModalProps,
    any
> {
    get injected() {
        return this.props as PaymentProcessFailedModalPropsInjected;
    }

    render() {
        const { modalProps, buttonProps, classes, t } = this.props;
        return (
            <Modal
                aria-labelledby='close-warning-title'
                aria-describedby='close-warning-description'
                open={false}
                {...modalProps}
            >
                <Paper className={classes.root}>
                    <div className={classes.header}>
                        <Typography variant='h3'>{t('Error')}</Typography>
                    </div>
                    <div className={classes.body}>
                        <Typography
                            variant='h4'
                            style={{ fontWeight: 'normal' }}
                        >
                            {t('We apologize for any inconvenience')}
                        </Typography>
                    </div>

                    <div className={classes.footer}>
                        <Button
                            variant='primary'
                            style={{ width: 200 }}
                            {...buttonProps}
                        >
                            <Typography variant='button'>{t('OK')}</Typography>
                        </Button>
                    </div>
                </Paper>
            </Modal>
        );
    }
}

export default withTranslation()(withStyles(styles)(PaymentProcessFailedModal));
